<template>
  <div class="out-padding out-margin">
    <span class="float-left">
      <v-btn icon color="primary" @click="e1 = e1 - 1" :disabled="e1 === 1">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn icon color="primary" @click="e1 = e1 + 1">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </span>
    <v-stepper
      v-model="e1"
      style="box-shadow: 0 0px 0px 0px rgba(0,0,0,.2),0 0px 0 rgba(0,0,0,.14),0 0px 0px 0 rgba(0,0,0,.12);
            background-color:transparent;"
      class="out-padding out-margin"
    >
      <v-stepper-items
        v-for="item in 2 + e1"
        :key="item.key"
        style="color: #005591"
      >
        <v-stepper-content :step="item" class="out-padding out-margin">
          <h3 class="text-center">
            {{
              moment(new Date())
                .locale("es-mx")
                .add(item * 7 - 7, "days")
                .format("MMMM YYYY")
            }}
          </h3>
          <br />
          <div style="overflow: scroll; max-width:100%">
            <v-btn-toggle
              v-model="position"
              tile
              color="primary accent-3"
              group
              class="d-flex"
            >
              <v-btn
                v-for="n in 7"
                @click="selectDay"
                :key="n.key"
                style="margin: 0.2vw; color: #005591"
                :disabled="
                  moment(new Date()).isAfter(
                    moment(new Date()).add(n - 11 + item * 7, 'days')
                  ) ||
                    (beginLimit !== ''
                      ? moment(
                          new Date(limitDay[0], limitDay[1] - 1, limitDay[2])
                        ).isSameOrAfter(
                          moment(new Date()).add(n - 12 + item * 7, 'days')
                        )
                      : false)
                "
              >
                {{
                  moment(new Date())
                    .add(n - 11 + item * 7, "days")
                    .format("D")
                }}
                <br />
                {{
                  moment(new Date())
                    .locale("es-mx")
                    .add(n - 11, "days")
                    .format("dddd")
                }}
              </v-btn>
            </v-btn-toggle>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import moment from "moment";

const props = {
  value: {
    default: "",
    type: String,
  },
  formReserv: undefined,
  beginLimit: {
    default: "",
    type: String,
  },
};

export default {
  data() {
    return {
      dayValue: undefined,
      position: undefined,
      e1: 1,
      increment: 0,
    };
  },
  computed: {
    limitDay() {
      let l = this.beginLimit;
      let limitArray = l.split("-");
      return limitArray;
    },
  },
  methods: {
    execute() {},
    async selectDay() {
      setTimeout(() => {
        this.dayValue = moment(new Date())
          .add(this.position + 1 + this.e1 * 7 - 11, "days")
          .format("YYYY-MM-DD");
        this.$emit("click", this.dayValue, this.formReserv);
      }, 500);
    },
  },
  props: props,
};
</script>

<style scoped></style>
